// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-form {
  width: 100%;
  margin: 3rem 0;
  position: relative;
  margin-bottom: 4rem;
  padding-top: 6rem;
  padding-bottom: 4rem;
}
.contact-flex {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contact-label {
  color: var(--darkGrey);
  text-align: left;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.contact-input-group {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.simple-input {
  border: 1px solid silver;
}
/* > Tablet */
@media only screen and (min-width: 677px) {
  .contact-form {
    width: 50vw;
    /* min-width: -webkit-fill-available; */
  }
  .contact-input-group {
    align-items: left;
  }
}
@media only screen and (min-width: var(--minWidthDesktopLarge)) {
  .contact-form {
    min-width: auto;
  }
}

/* .invalid-feedback {
  color: var(--error-red);
} */

.invalid-feedback {
  background: var(--error-red) !important;
  color: var(--text-color-light);
  padding: 10px !important;
  border-radius: 0 !important;
  position: relative;
  display: inline-block !important;
  box-shadow: 1px 1px 1px #aaaaaa;
  margin-top: 10px;
}
.invalid-feedback:before {
  content: '';
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid var(--error-red);
  position: absolute;
  top: -10px;
}
.contact-label:after {
  color: var(--error-red) !important;
}
.invalid-feedback input {
  background: #fff0f4;
  color: var(--error-red);
  border: 1px solid var(--error-red) !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/contactForm.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;AACA,aAAa;AACb;EACE;IACE,WAAW;IACX,uCAAuC;EACzC;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;GAEG;;AAEH;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C","sourcesContent":[".contact-form {\n  width: 100%;\n  margin: 3rem 0;\n  position: relative;\n  margin-bottom: 4rem;\n  padding-top: 6rem;\n  padding-bottom: 4rem;\n}\n.contact-flex {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.contact-label {\n  color: var(--darkGrey);\n  text-align: left;\n  margin-top: 2rem;\n  margin-bottom: 1rem;\n}\n\n.contact-input-group {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.simple-input {\n  border: 1px solid silver;\n}\n/* > Tablet */\n@media only screen and (min-width: 677px) {\n  .contact-form {\n    width: 50vw;\n    /* min-width: -webkit-fill-available; */\n  }\n  .contact-input-group {\n    align-items: left;\n  }\n}\n@media only screen and (min-width: var(--minWidthDesktopLarge)) {\n  .contact-form {\n    min-width: auto;\n  }\n}\n\n/* .invalid-feedback {\n  color: var(--error-red);\n} */\n\n.invalid-feedback {\n  background: var(--error-red) !important;\n  color: var(--text-color-light);\n  padding: 10px !important;\n  border-radius: 0 !important;\n  position: relative;\n  display: inline-block !important;\n  box-shadow: 1px 1px 1px #aaaaaa;\n  margin-top: 10px;\n}\n.invalid-feedback:before {\n  content: '';\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 10px solid var(--error-red);\n  position: absolute;\n  top: -10px;\n}\n.contact-label:after {\n  color: var(--error-red) !important;\n}\n.invalid-feedback input {\n  background: #fff0f4;\n  color: var(--error-red);\n  border: 1px solid var(--error-red) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
